<mat-form-field class="searcinput" appearance="outline">
  <input matInput placeholder="Cerca" i18n-placeholder='@@placeholder-Search' [formControl]="myControl" [matAutocomplete]="auto">
  <mat-icon matSuffix class="searchIcon" svgIcon='search' style="transform: translateY(3px);"></mat-icon>
  <!-- Autocomplete container -->
  <mat-autocomplete #auto="matAutocomplete">
    @for (option of filteredOptions | async; track option) {
      @if (option?.visibility !== 'private' || (option?.visibility === 'private' && merchantService.currentMerchant?.role === 'USER')) {
        <mat-option
          [value]="currentLanguage === 'it' ? option?.title_version_IT : option?.title_version_EN" style='padding:0;'>
          <div style='display:flex;justify-content: space-between; align-items:center' (click)="openPdf(option?.file)">
            @if (currentLanguage === 'it') {
              <span style="padding-left: 0.75em; font-weight: 400;">{{option?.title_version_IT}}</span>
            }
            @if (currentLanguage === 'en') {
              <span style="padding-left: 0.75em; font-weight: 400;">{{option?.title_version_EN}}</span>
            }
            @if (!currentLanguage) {
              <span style="padding-left: 0.75em; font-weight: 400;">{{option?.title_version_EN}}</span>
            }
            <mat-icon style="text-align:right;margin:0">keyboard_arrow_right</mat-icon>
          </div>
          <mat-divider></mat-divider>
        </mat-option>
      }
    }

  </mat-autocomplete>
</mat-form-field>
